import React, { ReactElement } from "react";
import { View } from "react-native";
import { Text } from "../../components/Text";
import { inputErrorStyles as styles } from "./styles";

type ErrorProps = {
  error?: string;
};

const InputError = ({ error = undefined }: ErrorProps): ReactElement | null => {
  return error ? (
    <View style={styles.errorContainer}>
      <Text style={styles.errorLabel}>{error}</Text>
    </View>
  ) : null;
};

export default InputError;
